import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { ApolloProvider } from "@apollo/client/react";
import { MainWrapper } from "@flixbus/honeycomb-react";
import graphqlClient from "@/services/graphqlClient";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { AppToastsProvider } from "@/components/AppToast";
import AppRoutes from "./AppRoutes";
import "./App.scss";

const App: React.FC<{ msalInstance: IPublicClientApplication }> = ({
  msalInstance,
}) => (
  <MsalProvider instance={msalInstance}>
    <ApolloProvider client={graphqlClient}>
      <ThemeProvider>
        <AppToastsProvider>
          <MainWrapper extraClasses="full-height">
            <AppRoutes />
          </MainWrapper>
        </AppToastsProvider>
      </ThemeProvider>
    </ApolloProvider>
  </MsalProvider>
);

export default App;
